'use strict'

angular.module('rmRundown')
    .controller('RundownOverviewCtrl', require('./rundown_overview_ctrl'))
    .controller('RundownDraftsCtrl', require('./rundown_drafts_ctrl'))
    .controller('RundownEditCtrl', require('./rundown_edit_ctrl'))
    .controller('DragDropFiltersWarning', ['$scope', '$mdDialog', ($scope, $mdDialog) => $scope.$mdDialog = $mdDialog])
